import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth-service';
import { environment } from '../../../../environments/environment';
import { LookupResponse } from '../../../components/admin-dashboard-component/orders/view-order-details/actions/item-status-table/item-status-table.model';

@Injectable({
  providedIn: 'root',
})
export class OrderLookupService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private API = environment.pharmacyMgtApiUrl;

  private getHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }

  getPartiallyPackageReasons(): Observable<LookupResponse> {
    return this.http.get<LookupResponse>(`${this.API}/lookup/orders/partially/package/reasons`, {
      headers: this.getHeaders(),
    });
  }

  getUndeliveryReasons(): Observable<LookupResponse> {
    return this.http.get<LookupResponse>(`${this.API}/lookup/orders/undelivery/reasons`, {
      headers: this.getHeaders(),
    });
  }
}
